import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VistaService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getModulos(): Observable<any> {

    return this.http.get(this.baseUrl + 'modulos', { headers: this.header(this.token) });
  }
  
  getVistas(): Observable<any> {

    return this.http.get(this.baseUrl + 'vistas', { headers: this.header(this.token) });
  }

  postVista(Ods: any): Observable<any> {
    return this.http.post(this.baseUrl + 'postVista', Ods, { headers: this.header(this.token) });
  }

  putVista(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'putVista', bodyString, { headers: this.header(this.token) });
  }

  deleteVista(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteVista/' + id, { headers: this.header(this.token) });
  }

  getVistaAsignadoaRol(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'vistaAsignadoaRol/' + id, { headers: this.header(this.token) });
  }

  deleteVistaAsignado(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteVistaAsignado/' + id, { headers: this.header(this.token) });
  }

  postVistaAsignadoaRol(vista: any): Observable<any> {
    return this.http.post(this.baseUrl + 'postVistaAsignadoaRol', vista, { headers: this.header(this.token) });
  }

  postModulo(modulo: any): Observable<any> {
    return this.http.post(this.baseUrl + 'postModulo', modulo, { headers: this.header(this.token) });
  }

  
}